module.exports = __webpack_public_path__ + "static/media/shell32_13.5e4b3c07.ico";